import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-bold h-mv-0 h-ml-10 h-font-14" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "b-back-button h-inline-flex h-pointer",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routeString ? _ctx.$router.push({ name: _ctx.routeString }) : _ctx.$router.back(`-1`)))
  }, [
    _createVNode(_component_FwIcon, {
      class: "h-flex-center h-pointer",
      icon: "arrow-left",
      size: "14",
      color: "rgba(33,63,107,.3)"
    }),
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('BUTTON.BACK')), 1)
  ]))
}